// status defaults to review+running (the old initialFilter default).
export const INITIAL_CAMPAIGNS_FILTERS = {
  countries: [],
  period: null,
  status: ['review', 'running'],
  adops: [],
  customers: [],
  paidStatus: '',
  query: '',
}
